export const Component404 = () => {
  return (
    <div className='utility-page-wrap'>
      <div className='utility-page-content'>
        <img src='https://d3e54v103j8qbb.cloudfront.net/static/page-not-found.211a85e40c.svg' alt='page not foound' />
        <h2>Página no encontrada</h2>
        <div>La página que busca no existe o ha sido movida</div>
      </div>
    </div>
  )
}
